import { render } from "./ProductCard.vue?vue&type=template&id=f324082a&scoped=true"
import script from "./ProductCard.vue?vue&type=script&lang=ts"
export * from "./ProductCard.vue?vue&type=script&lang=ts"

import "./ProductCard.vue?vue&type=style&index=0&id=f324082a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f324082a"

export default script